/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { GeoPoint } from './GeoPoint';
import {
    GeoPointFromJSON,
    GeoPointFromJSONTyped,
    GeoPointToJSON,
} from './GeoPoint';
import type { Image } from './Image';
import {
    ImageFromJSON,
    ImageFromJSONTyped,
    ImageToJSON,
} from './Image';
import type { OpeningSchedule } from './OpeningSchedule';
import {
    OpeningScheduleFromJSON,
    OpeningScheduleFromJSONTyped,
    OpeningScheduleToJSON,
} from './OpeningSchedule';

/**
 * Representation of a Point of service
 * @export
 * @interface PointOfService
 */
export interface PointOfService {
    /**
     * Name of the point of service
     * @type {string}
     * @memberof PointOfService
     */
    name?: string;
    /**
     * Display name of the point of service
     * @type {string}
     * @memberof PointOfService
     */
    displayName?: string;
    /**
     * Url address of the point of service
     * @type {string}
     * @memberof PointOfService
     */
    url?: string;
    /**
     * Description of the point of service
     * @type {string}
     * @memberof PointOfService
     */
    description?: string;
    /**
     * 
     * @type {OpeningSchedule}
     * @memberof PointOfService
     */
    openingHours?: OpeningSchedule;
    /**
     * Store content of given point of service
     * @type {string}
     * @memberof PointOfService
     */
    storeContent?: string;
    /**
     * List of features for a given point of service
     * @type {{ [key: string]: string; }}
     * @memberof PointOfService
     */
    features?: { [key: string]: string; };
    /**
     * 
     * @type {GeoPoint}
     * @memberof PointOfService
     */
    geoPoint?: GeoPoint;
    /**
     * Distance to the point of service as text value
     * @type {string}
     * @memberof PointOfService
     */
    formattedDistance?: string;
    /**
     * Distance to the point of service as number value
     * @type {number}
     * @memberof PointOfService
     */
    distanceKm?: number;
    /**
     * 
     * @type {Image}
     * @memberof PointOfService
     */
    mapIcon?: Image;
    /**
     * 
     * @type {Address}
     * @memberof PointOfService
     */
    address?: Address;
    /**
     * Collection of images associated with a point of service
     * @type {Array<Image>}
     * @memberof PointOfService
     */
    storeImages?: Array<Image>;
    /**
     * Instructions used for picking up an order in store
     * @type {string}
     * @memberof PointOfService
     */
    pickUpInStoreInstructions?: string;
}

/**
 * Check if a given object implements the PointOfService interface.
 */
export function instanceOfPointOfService(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PointOfServiceFromJSON(json: any): PointOfService {
    return PointOfServiceFromJSONTyped(json, false);
}

export function PointOfServiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PointOfService {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'openingHours': !exists(json, 'openingHours') ? undefined : OpeningScheduleFromJSON(json['openingHours']),
        'storeContent': !exists(json, 'storeContent') ? undefined : json['storeContent'],
        'features': !exists(json, 'features') ? undefined : json['features'],
        'geoPoint': !exists(json, 'geoPoint') ? undefined : GeoPointFromJSON(json['geoPoint']),
        'formattedDistance': !exists(json, 'formattedDistance') ? undefined : json['formattedDistance'],
        'distanceKm': !exists(json, 'distanceKm') ? undefined : json['distanceKm'],
        'mapIcon': !exists(json, 'mapIcon') ? undefined : ImageFromJSON(json['mapIcon']),
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'storeImages': !exists(json, 'storeImages') ? undefined : ((json['storeImages'] as Array<any>).map(ImageFromJSON)),
        'pickUpInStoreInstructions': !exists(json, 'pickUpInStoreInstructions') ? undefined : json['pickUpInStoreInstructions'],
    };
}

export function PointOfServiceToJSON(value?: PointOfService | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'displayName': value.displayName,
        'url': value.url,
        'description': value.description,
        'openingHours': OpeningScheduleToJSON(value.openingHours),
        'storeContent': value.storeContent,
        'features': value.features,
        'geoPoint': GeoPointToJSON(value.geoPoint),
        'formattedDistance': value.formattedDistance,
        'distanceKm': value.distanceKm,
        'mapIcon': ImageToJSON(value.mapIcon),
        'address': AddressToJSON(value.address),
        'storeImages': value.storeImages === undefined ? undefined : ((value.storeImages as Array<any>).map(ImageToJSON)),
        'pickUpInStoreInstructions': value.pickUpInStoreInstructions,
    };
}

